import { render, staticRenderFns } from "./CompanyAdminActions.vue?vue&type=template&id=03f5b780&scoped=true"
import script from "./CompanyAdminActions.vue?vue&type=script&lang=js"
export * from "./CompanyAdminActions.vue?vue&type=script&lang=js"
import style0 from "./CompanyAdminActions.vue?vue&type=style&index=0&id=03f5b780&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f5b780",
  null
  
)

export default component.exports